import {Component} from '@angular/core';
import {FormGroup, FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import {startWith} from 'rxjs/operators/startWith';
import {map} from 'rxjs/operators/map';

import * as d3 from 'd3';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import * as d3Tip from 'd3-tip';
(d3 as any).tip = d3Tip;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Maternidad subrogada';

  topic = 'coeficiente_TAI';
  topics = {
    'coeficiente_TAI': {
      colors: {
        default: ['#e2e2ed', '#c8c8d4', '#aeaebb', '#9494a2', '#7a7a89'],
        onHover: ['#cea052', '#b5805b', '#9d5f63', '#843f6c', '#6b1e74']
      }
    },
    'opacidad': {
      colors: {
        default: ['#e2e2ed', '#c8c8d4', '#aeaebb', '#9494a2', '#7a7a89'],
        onHover: ['#cea052', '#d49141', '#da822f', '#df731e', '#e5640c']
      }
    },
    'corrupcion': {
      colors: {
        default: ['#e2e2ed', '#c8c8d4', '#aeaebb', '#9494a2', '#7a7a89'],
        onHover: ['#cea052', '#9b9354', '#678656', '#347858', '#006b5a']
      }
    },
    'impunidad': {
      colors: {
        default: ['#e2e2ed', '#c8c8d4', '#aeaebb', '#9494a2', '#7a7a89'],
        onHover: ['#cea052', '#9f845a', '#706861', '#404b69', '#112f70']
      }
    },
  }

  colors = this.topics['coeficiente_TAI'].colors;
  selectedOne = null; // Variable that share all components
  selectedTwo = null; // Variable that share all components

  selectedOneModel = null; // NgModel for the autocomplete
  autoOne = null; // Temp Variable for the autocomplete

  selectedTwoModel = null; // NgModel for the autocomplete
  autoTwo = null; // Temp Variable for the autocomplete

  hover= null;
  unhover = null;

  // ------------------------------------------------------------
  myControl: FormControl = new FormControl();
  myControlOne: FormControl = new FormControl();
  myControlTwo: FormControl = new FormControl();

  options = [
    'Aguascalientes',
    'Baja California',
    'Baja California Sur',
    'Campeche',
    'Coahuila de Zaragoza',
    'Colima',
    'Chiapas',
    'Chihuahua',
    'Ciudad de México',
    'Durango',
    'Guanajuato',
    'Guerrero',
    'Hidalgo',
    'Jalisco',
    'México',
    'Michoacán de Ocampo',
    'Morelos',
    'Nayarit',
    'Nuevo León',
    'Oaxaca',
    'Puebla',
    'Querétaro',
    'Quintana Roo',
    'San Luis Potosí',
    'Sinaloa',
    'Sonora',
    'Tabasco',
    'Tamaulipas',
    'Tlaxcala',
    'Veracruz de Ignacio de la Llave',
    'Yucatán',
    'Zacatecas'
  ];

  filteredOptionsOne: Observable<string[]>;
  filteredOptionsTwo: Observable<string[]>;

  ngOnInit() {
    this.filteredOptionsOne = this.myControlOne.valueChanges
    .pipe(
      startWith(''),
      map(val => this.filter(val))
    );

    this.filteredOptionsTwo = this.myControlTwo.valueChanges
    .pipe(
      startWith(''),
      map(val => this.filter(val))
    );

    $('ul.tabs').tabs();

    d3.selectAll('.state-tip-scatter.n').remove();
  }

  filter(val: string): string[] {
    return this.options.filter(option =>
      option.toLowerCase().indexOf(val.toLowerCase()) === 0);
  }

  changeTopic(topic) {

    let vm = this;

    d3.selectAll('.stip').remove();
    d3.select('.national-tip').remove();
    d3.select('.scatter-tip').remove();
    d3.selectAll('.state-tip-scatter.n').remove();

    d3.selectAll('.tabs.tabs-transparent a')
      .classed('active', false);

    d3.select('.tabs.tabs-transparent .tab.' + topic + ' a').classed('active', true);

    this.colors = this.topics[topic].colors;
    this.topic = topic;
    d3.selectAll('.d3-tip').remove();
    // Waiting for chart to redraw and place tooltips
    setTimeout(function(){
      // Looping through all bar and selecting the ones with color to show tooltip
      d3.select('#bars svg').selectAll('.bar').each(function(d, i){

        let color = d3.select(this).attr('fill');
        if (d3.select(this).attr('fill') === "#e2e2ed" || d3.select(this).attr('fill') === "#c8c8d4"
          || d3.select(this).attr('fill') === '#aeaebb' || d3.select(this).attr('fill') === '#9494a2'
          || d3.select(this).attr('fill') === '#7a7a89') {
          d3.selectAll('.state-tip-' + d['CVE_ENT']).remove();
        }
        else if (i !== 32) { // 32 is for National, its tootip is defined on Map component
          let stateTip = d3Tip().attr('class', 'stip state-tip-' + d['CVE_ENT']);
          let stateSelection = vm.selectedTopic(d);

          stateTip.html(function(){
            return stateSelection;
          });

          d3.select('#bars svg').call(stateTip);
          let stateBar = d3.select('#bars #bars-' + d['CVE_ENT']);

          stateBar.each(function(d){
            stateTip.show(stateSelection, stateBar.node());
          });
          d3.select('.state-tip-' + d['CVE_ENT'])
            .style('color', d3.select(this).attr('fill'));
        }

      });
    }, 200);
  }

  stateOneSelected(data) {
    if (this.selectedOne !== null) {
      // Reset previous selection
      this.onHoverOutUserSelection(this.selectedOne);
    }
    const stateId = this.options.indexOf(data.option.value) + 1;
    this.selectedOne = {d: {'CVE_ENT': stateId.toString()}, by: 'user'}
  }

  stateTwoSelected(data) {
    if (this.selectedTwo !== null) {
      // Reset previous selection
      this.onHoverOutUserSelection(this.selectedTwo);
    }
    const stateId = this.options.indexOf(data.option.value) + 1;
    this.selectedTwo = {d: {'CVE_ENT': stateId.toString()}, by: 'user'}
  }

  /**
   * Recieves the polygon data selected by the user
   * @param data object from the child component dboxMap
   */
  onClickMap(data) {
    // console.log('onClickMap component', data.d, data.i)
    data.by = 'map'

    if (this.selectedOne == null) {
      // If the first selection is missing
      this.selectedOne = data;
      this.selectedOneModel = this.options[parseInt(data.d.CVE_ENT, 10) - 1]
      this.autoOne = this.options[parseInt(data.d.CVE_ENT, 10) - 1]
    } else if (this.selectedOne.d.CVE_ENT === data.d.CVE_ENT) {
      // If clicked on the same selection
      this.onHoverOutUserSelection(this.selectedOne);
      this.selectedOne = null;
      this.selectedOneModel = ''; // reset autocomplete
      this.autoOne = ''; // reset autocomplete
    } else {
      // Update the second selection

      if (this.selectedTwo !== null) {
        // Reset the previous selection
        this.onHoverOutUserSelection(this.selectedTwo);
      }

      if (this.selectedTwo !== null && this.selectedTwo.d.CVE_ENT === data.d.CVE_ENT) {
        // If clicked on the same selection, reset
        this.selectedTwo = null;
        this.selectedTwoModel = ''; // reset autocomplete
        this.autoTwo = ''; // reset autocomplete
      } else {
        // Set the second selection
        this.selectedTwo = data;
        this.selectedTwoModel = this.options[parseInt(data.d.CVE_ENT, 10) - 1];
        this.autoTwo = this.options[parseInt(data.d.CVE_ENT, 10) - 1];
      }
    }
  }

  onHoverOutUserSelection(data) {
    // console.log('User selected a new state to compare')
    data.by = 'user'
    this.unhover = data;
  }

  onHoverMap(data) {
    // console.log('Map component hovered', data.d, data.i)
    data.by = 'map'
    this.hover = data;
  }

  onHoverOutMap(data) {
    // console.log('Map component hovered Out', data.d, data.i)
    data.by = 'map'
    this.unhover = data;
  }

  onClickBars(data) {
    // console.log('onClickBars component', data.d, data.i)
    data.by = 'bars';

    if (this.selectedOne == null) {
      // If the first selection is missing
      this.selectedOne = data;
      this.selectedOneModel = this.options[parseInt(data.d.CVE_ENT, 10) - 1]
    } else if (this.selectedOne.d.CVE_ENT === data.d.CVE_ENT) {

      // If clicked on the same selection
      d3.select('.state-tip-scatter.n#state-' + this.selectedOne.d.CVE_ENT).remove();
      this.onHoverOutUserSelection(this.selectedOne);
      this.selectedOne = null;
      this.selectedOneModel = '';
    } else {
      // Update the second selection

      if (this.selectedTwo !== null) {
        // Reset the previous selection
        this.onHoverOutUserSelection(this.selectedTwo);
      }

      if (this.selectedTwo !== null && this.selectedTwo.d.CVE_ENT === data.d.CVE_ENT) {
        // If clicked on the same selection, reset
        d3.select('.state-tip-scatter.n#state-' + this.selectedTwo.d.CVE_ENT).remove();
        this.selectedTwo = null;
        this.selectedTwoModel = '';
      } else {
        // Set the second selection
        this.selectedTwo = data;
        this.selectedTwoModel = this.options[parseInt(data.d.CVE_ENT, 10) - 1]
      }

    }

  }

  onHoverBars(data) {
    // console.log('onHoverBars component', data.d, data.i)
    data.by = 'bars';
    this.hover = data;
  }

  onHoverOutBars(data) {
    // console.log('onHoverOutBars component ', data.d, data.i)
    data.by = 'bars';
    this.unhover = data;
  }

  onScatterTopicChange(data) {
    data.by = 'scatter';
    this.changeTopic(data.topic);
  }

  onRadarTopicChange(data) {
    // console.log('onScatterTopicChange component ', data)
    data.by = 'radar';
    this.changeTopic(data.topic);
  }

   /** selectedTopic: get variable selected from navbar in map
   * @returns {string}
   * @since v2
  */
  selectedTopic(data){
    let actualClass = d3.select('.nav-extended .tabs-transparent .active').attr('class');
    let actual = actualClass.split(' ');
    let format = d3.format('.2f');

    switch(actual[0]){
      case 'coeficiente_TAI':
        return format(data.coeficiente_TAI);
      case 'corrupcion':
        return format(data.corrupcion);
      case 'impunidad':
        return format(data.impunidad);
      case 'opacidad':
        return format(data.opacidad);
    }
  }
}



// WEBPACK FOOTER //
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/app.component.ts